import { defineComponent, ref, computed, onMounted, openBlock, createElementBlock, normalizeClass, createVNode, unref, withCtx, createElementVNode, toDisplayString, createCommentVNode, withDirectives, vShow, createTextVNode, Fragment, renderList, withModifiers } from "vue";
import { CdrFormGroup } from "@rei/cedar";
const _hoisted_1 = ["data-color"];
const _hoisted_2 = {
  class: "pdp-sr-only"
};
const _hoisted_3 = {
  "aria-hidden": "true"
};
const _hoisted_4 = {
  class: "color-selector-wrapper__labelName"
};
const _hoisted_5 = {
  class: "color-selector-wrapper__selected-color"
};
const _hoisted_6 = {
  key: 0,
  class: "color-selector-wrapper__clearance-message"
};
const _hoisted_7 = {
  class: "color-selector-wrapper__sold-out-text"
};
const _hoisted_8 = {
  class: "color-selector-wrapper__colors"
};
const _hoisted_9 = ["aria-current", "name", "data-color", "data-skus-color", "data-ui", "onClick", "onMouseover", "onFocusin"];
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = {
  id: "color-error-text",
  class: "color-selector-wrapper__error-text"
};
const _hoisted_12 = {
  key: 0,
  class: "pdp-sr-only"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxColorSelector",
  props: {
    error: {
      type: Boolean
    },
    groupedColors: {
      default: () => []
    },
    label: {},
    showGroups: {
      type: Boolean
    },
    selectedColor: {
      default: () => ({
        name: "",
        code: "",
        colorFamily: "",
        displayLabel: "",
        hexValue: [],
        badges: []
      })
    },
    selectedPrice: {
      default: void 0
    },
    selectedColorIsAvailable: {
      type: Boolean
    },
    skusForColor: {},
    styleId: {},
    selectedPriceClearanceMessage: {
      default: ""
    },
    tileSize: {
      default: "40"
    }
  },
  emits: ["colorHover", "colorUpdate", "registerRef"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const fieldset = ref(null);
    const emit = __emit;
    const computedLabel = computed(() => props.selectedColor.displayLabel ? `${props.label}: ` : `Select a ${props.label.toLowerCase()}`);
    const srText = computed(() => {
      if (props.selectedColor.code) {
        const message = `${computedLabel.value}${props.selectedColor.displayLabel}${!props.selectedColorIsAvailable ? ", sold out" : ""}`;
        return message;
      }
      return `please select a ${props.label}`;
    });
    onMounted(() => {
      var _a;
      emit("registerRef", {
        type: "color",
        value: (_a = fieldset == null ? void 0 : fieldset.value) == null ? void 0 : _a.$el
      });
    });
    const handleColorChange = (color, price) => {
      emit("colorUpdate", {
        color,
        price,
        metrics: {
          linkName: "select color"
        }
      });
    };
    const getAvailabilityText = (available) => available ? "available" : "unavailable";
    const getDataSkusColor = (color) => {
      var _a;
      let attribute = [];
      if (Array.isArray((_a = props.skusForColor) == null ? void 0 : _a[color.code])) {
        attribute = [...props.skusForColor[color.code]];
      }
      return attribute;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["color-selector-wrapper", {
          "color-selector-wrapper--error": _ctx.error
        }])
      }, [createVNode(unref(CdrFormGroup), {
        ref_key: "fieldset",
        ref: fieldset,
        error: _ctx.error,
        "error-role": "text",
        "data-ui": "color-selector-fieldset",
        tabindex: _ctx.error ? -1 : null,
        "aria-describedby": _ctx.error ? "color-error-text" : null
      }, {
        label: withCtx(() => [createElementVNode("div", {
          id: "color-selector-wrapper-label",
          class: "color-selector-wrapper__label",
          "data-color": _ctx.selectedColor.name
        }, [createElementVNode("span", _hoisted_2, toDisplayString(srText.value), 1), createElementVNode("span", _hoisted_3, [createElementVNode("span", _hoisted_4, toDisplayString(computedLabel.value), 1), createElementVNode("span", _hoisted_5, toDisplayString(_ctx.selectedColor.displayLabel), 1), _ctx.selectedPriceClearanceMessage ? (openBlock(), createElementBlock("span", _hoisted_6, " (" + toDisplayString(_ctx.selectedPriceClearanceMessage) + ") ", 1)) : createCommentVNode("", true), withDirectives(createElementVNode("span", _hoisted_7, " - Sold out ", 512), [[vShow, !_ctx.selectedColorIsAvailable]])])], 8, _hoisted_1)]),
        error: withCtx(() => [createElementVNode("span", _hoisted_11, [_cache[2] || (_cache[2] = createTextVNode(" Please select an available color ")), !_ctx.selectedColorIsAvailable ? (openBlock(), createElementBlock("span", _hoisted_12, " , current selected color is sold out ")) : createCommentVNode("", true)])]),
        default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.groupedColors, (group) => {
          var _a, _b, _c, _d, _e, _f;
          return openBlock(), createElementBlock("div", {
            key: ((_a = group.priceData) == null ? void 0 : _a.price) ? group.priceData.price.value : "single-price"
          }, [_ctx.showGroups ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["color-selector-wrapper__price-for-group", {
              "color-selector-wrapper__price-for-group--sale": (_c = (_b = group.priceData) == null ? void 0 : _b.price) == null ? void 0 : _c.sale
            }])
          }, " $" + toDisplayString((_f = (_e = (_d = group.priceData) == null ? void 0 : _d.price) == null ? void 0 : _e.value) == null ? void 0 : _f.toFixed(2)), 3)) : createCommentVNode("", true), createElementVNode("div", _hoisted_8, [(openBlock(true), createElementBlock(Fragment, null, renderList(group.colors, ({
            color,
            available
          }) => {
            var _a2, _b2, _c2, _d2;
            return openBlock(), createElementBlock("button", {
              key: color.code + (((_c2 = (_b2 = (_a2 = group.priceData) == null ? void 0 : _a2.price) == null ? void 0 : _b2.value) == null ? void 0 : _c2.toString()) ? group.priceData.price.value.toString() : ""),
              type: "button",
              "aria-current": _ctx.selectedColor.code === color.code,
              name: color.code.toString(),
              class: normalizeClass(["color-btn", {
                "color-btn--unavailable": !available,
                "color-btn--selected": (!((_d2 = group == null ? void 0 : group.priceData) == null ? void 0 : _d2.price) || _ctx.selectedPrice === group.priceData.price.value) && _ctx.selectedColor.code === color.code
              }]),
              "data-color": color.name,
              "data-skus-color": getDataSkusColor(color),
              "data-ui": getAvailabilityText(available),
              onClick: withModifiers(($event) => handleColorChange(color, group == null ? void 0 : group.priceData), ["prevent"]),
              onMouseover: ($event) => _ctx.$emit("colorHover", {
                color,
                priceData: group.priceData
              }),
              onMouseleave: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("colorHover", {})),
              onFocusin: ($event) => _ctx.$emit("colorHover", {
                color,
                priceData: group.priceData
              }),
              onFocusout: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("colorHover", {}))
            }, [createElementVNode("img", {
              class: "color-btn__color-thumb",
              src: `/media/color/${_ctx.styleId}.jpg?colorId=${color.code}&size=${_ctx.tileSize}`,
              alt: `Color: ${color.displayLabel}${available ? "" : ", sold out"}`
            }, null, 8, _hoisted_10)], 42, _hoisted_9);
          }), 128))])]);
        }), 128))]),
        _: 1
      }, 8, ["error", "tabindex", "aria-describedby"])], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxColorSelector2.mjs.map
